/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./houses-router.component";
var styles_HousesRouterComponent = [];
var RenderType_HousesRouterComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_HousesRouterComponent, data: {} });
export { RenderType_HousesRouterComponent as RenderType_HousesRouterComponent };
export function View_HousesRouterComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i0.ɵdid(1, 212992, null, 0, i1.RouterOutlet, [i1.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_HousesRouterComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-houses-router", [], null, null, null, View_HousesRouterComponent_0, RenderType_HousesRouterComponent)), i0.ɵdid(1, 49152, null, 0, i2.HousesRouterComponent, [], null, null)], null, null); }
var HousesRouterComponentNgFactory = i0.ɵccf("app-houses-router", i2.HousesRouterComponent, View_HousesRouterComponent_Host_0, {}, {}, []);
export { HousesRouterComponentNgFactory as HousesRouterComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/houses/houses-router.component.ngfactory.js.pre-build-optimizer.js